import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GridModule } from '@ui/grid/grid.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { initTheme } from './initializers/theme.initialiser';
import { ThemeState } from '@shared/states/theme.state';
import { AppInjector } from '@shared/config/app-injector';
import { CommonModule } from '@angular/common';
import { ToastModule } from '@ui/toast/toast.module';
import { NavigationPanelModule } from '@ui/navigation-panel/navigation-panel.module';
import { NoFoundComponent } from './no-found/no-found.component';
import { SvgModule } from '@ui/svg/svg.module';
import { ButtonModule } from '@ui/button/button.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { PipesModule } from '@shared/pipes/pipes.module';

@NgModule({
  declarations: [AppComponent, NoFoundComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initTheme,
      multi: true,
      deps: [ThemeState],
    },
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    GridModule,
    BrowserAnimationsModule,
    ToastModule,
    NavigationPanelModule,
    SvgModule,
    ButtonModule,
    DirectivesModule,
    PipesModule,
  ],
})
export class AppModule {
  constructor(private injector: Injector) {
    AppInjector.Injector = injector;
  }
}
